<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import axios from '../axios.js'

const emit = defineEmits(['close'])

// League options - from proballers.tools.oddscomposer.io/backend_new_v2/server.js
const leagues = [
  { id: 177, name: 'EuroLeague' },
  { id: 3, name: 'NBA' },
  { id: 397, name: 'WNBA' },
  { id: 192, name: 'EuroCup' },
  { id: 200, name: 'Lithuania Betsafe LKL' },
  { id: 233, name: 'Lithuania Betsafe LKL Playoffs' },
  { id: 281, name: 'Japan B1 League' },
  { id: 100024, name: 'Latvian-Estonian Basketball League' },
  { id: 100038, name: 'Latvian-Estonian Basketball League PO' },
  { id: 196, name: 'FIBA Europe Cup' },
  { id: 422, name: 'Basketball Champions League' },
  { id: 1, name: 'France Betclic Elite' },
  { id: 181, name: 'Finland Korisliiga' },
  { id: 170, name: 'Poland PLK' },
  { id: 30, name: 'Spain Liga Endesa' },
  { id: 65, name: 'Spain Liga Endesa Playoffs' },
  { id: 40, name: 'Italy LBA Serie A' },
  { id: 168, name: 'Turkey BSL' },
  { id: 50, name: 'Greece HEBA A1' },
  { id: 190, name: 'Sweden Basketligan' },
  { id: 274, name: 'World Cup' },
  { id: 143, name: 'EuroBasket' },
  { id: 425, name: 'World Cup European Qualifiers' },
  { id: 179, name: 'EuroBasket Qualifying Rounds' },
  { id: 6, name: 'Olympic Games' },
  { id: 381, name: 'Olympic Games Qualifying Tournament' },
  { id: 400, name: 'Olympic Games W' },
  { id: 401, name: 'World Cup W' },
  { id: 100085, name: 'World Cup African Qualifiers' },
  { id: 100077, name: 'World Cup Americas Qualifiers' },
  { id: 100086, name: 'World Cup Asian Qualifiers' },
  { id: 382, name: 'U19 World Cup' },
  { id: 100052, name: 'U19 Women\'s World Cup W' },
  { id: 380, name: 'U17 World Cup' },
  { id: 100084, name: 'U17 World Cup W' },
  { id: 100042, name: 'EuroBasket W' },
  { id: 229, name: 'U20 European Championship' },
  { id: 100083, name: 'U20 European Championship W' },
  { id: 346, name: 'U20 European Championship Div B' },
  { id: 100082, name: 'U20 European Championship W Div B' },
  { id: 165, name: 'U18 European Championship' },
  { id: 100080, name: 'U18 European Championship W' },
  { id: 163, name: 'U18 European Championship Div B' },
  { id: 100081, name: 'U18 European Championship W Div B' },
  { id: 232, name: 'U16 European Championship' },
  { id: 100078, name: 'U16 European Championship W' },
  { id: 164, name: 'U16 European Championship Div B' },
  { id: 100079, name: 'U16 European Championship W Div B' },
  { id: 395, name: 'EuroLeague Women W' },
  { id: 396, name: 'EuroCup Women W' },
  { id: 284, name: 'Adriatic Liga ABA Playoffs' },
  { id: 182, name: 'Adriatic Liga ABA' },
  { id: 100099, name: 'Adriatic ABA Liga 2' },
  { id: 100029, name: 'Adriatic Junior ABA League' },
  { id: 272, name: 'VTB United League' },
  { id: 368, name: 'VTB United League Play-offs' },
  { id: 100032, name: 'Adidas Next Generation Tournament' },
  { id: 10, name: 'NBA Playoffs' },
  { id: 221, name: 'G-League' },
  { id: 295, name: 'G-League Play-offs' },
  { id: 398, name: 'WNBA Play-offs W' },
  { id: 5, name: 'NCAA' },
  { id: 329, name: 'Nike Hoop Summit' },
  { id: 354, name: 'Canada NBL' },
  { id: 360, name: 'Canada NBL Play-offs' },
  { id: 188, name: 'Argentina Liga A' },
  { id: 280, name: 'Argentina Liga A Playoffs' },
  { id: 100030, name: 'Argentina La Liga Torneo Super 20' },
  { id: 100028, name: 'Basketball Champions League Americas' },
  { id: 100035, name: 'Mexico Liga Sisnova LNBP' },
  { id: 100034, name: 'Mexico Liga Sisnova LNBP Play-offs' },
  { id: 270, name: 'Puerto Rico BSN' },
  { id: 271, name: 'Puerto Rico BSN Play-offs' },
  { id: 226, name: 'Australia NBL' },
  { id: 239, name: 'Australia NBL Playoffs' },
  { id: 359, name: 'New Zealand NBL' },
  { id: 361, name: 'New Zealand NBL Play-offs' },
  { id: 159, name: 'China CBA' },
  { id: 158, name: 'China CBA Play-offs' },
  { id: 155, name: 'Japan B1 League Play-offs' },
  { id: 103, name: 'Japan B2 League' },
  { id: 64, name: 'Japan B2 League Play-offs' },
  { id: 100031, name: 'Basketball Africa League' },
  { id: 100041, name: 'Basketball Africa League Play-offs' },
  { id: 189, name: 'Austria Bundesliga' },
  { id: 255, name: 'Austria Bundesliga Playoffs' },
  { id: 352, name: 'Belarus Premier League' },
  { id: 377, name: 'Belarus Premier League Playoffs' },
  { id: 141, name: 'Belgium Euromillions Basketball League' },
  { id: 247, name: 'Belgium Euromillions Basketball League Playoffs' },
  { id: 187, name: 'Bosnia Division I' },
  { id: 345, name: 'Bosnia Division I Playoffs' },
  { id: 120, name: 'British Basketball' },
  { id: 259, name: 'British Basketball Playoffs' },
  { id: 186, name: 'Bulgaria NBL' },
  { id: 304, name: 'Bulgaria NBL Play-offs' },
  { id: 288, name: 'Bulgaria Division A' },
  { id: 100025, name: 'Bulgaria Division A Play-offs' },
  { id: 185, name: 'Croatia Liga' },
  { id: 266, name: 'Croatia Liga Play-offs' },
  { id: 183, name: 'Czech Republic Mattoni NBL' },
  { id: 245, name: 'Czech Republic Mattoni NBL Play-offs' },
  { id: 238, name: 'Denmark Ligaen' },
  { id: 248, name: 'Denmark Ligaen Play-offs' },
  { id: 243, name: 'Finland Korisliiga Play-offs' },
  { id: 407, name: 'Finland 1st Division A' },
  { id: 409, name: 'Finland 1st Division A Play-offs' },
  { id: 408, name: 'Finland 1st Division B' },
  { id: 410, name: 'Finland 1st Division B Play-offs' },
  { id: 57, name: 'France Betclic Elite Play-offs' },
  { id: 426, name: 'France Pro A Leaders Cup' },
  { id: 130, name: 'France Betclic Elite U21' },
  { id: 197, name: 'France Betclic Elite U21 Trophee du Futur' },
  { id: 363, name: 'France LFB W' },
  { id: 371, name: 'France LFB Play-offs W' },
  { id: 100036, name: 'France LF2 W' },
  { id: 100051, name: 'France LF2 Play-offs W' },
  { id: 2, name: 'France Pro B' },
  { id: 131, name: 'France Pro B U21' },
  { id: 82, name: 'France NM-1' },
  { id: 256, name: 'France NM-1 Play-offs' },
  { id: 100027, name: 'France Coupe de France' },
  { id: 100050, name: 'France Coupe de France W' },
  { id: 317, name: 'Georgia Superleague' },
  { id: 411, name: 'Georgia Superleague Play-offs' },
  { id: 118, name: 'Germany EasyCredit BBL' },
  { id: 138, name: 'Germany EasyCredit BB Play-offs' },
  { id: 276, name: 'Germany Pro A' },
  { id: 369, name: 'Germany Pro A Play-offs' },
  { id: 63, name: 'Greece HEBA A1 Play-offs' },
  { id: 275, name: 'Greece HEBA A2' },
  { id: 424, name: 'Greece HEBA A2 Play-offs' },
  { id: 169, name: 'Hungary A League' },
  { id: 322, name: 'Iceland Express League' },
  { id: 60, name: 'Italy LBA Serie A Play-offs' },
  { id: 100021, name: 'Italy Serie A2 Girone Est' },
  { id: 100018, name: 'Italy Serie A2 Girone Ovest' },
  { id: 330, name: 'Italy Serie B Girone A' },
  { id: 331, name: 'Italy Serie B Girone B' },
  { id: 100008, name: 'Italy Serie B Girone C' },
  { id: 100009, name: 'Italy Serie B Girone D' },
  { id: 156, name: 'Lithuania NKL' },
  { id: 208, name: 'Netherlands Eredivisie' },
  { id: 325, name: 'Norway BLNO' },
  { id: 321, name: 'Poland 1 Liga' },
  { id: 139, name: 'Portugal Liga Profissional' },
  { id: 257, name: 'Romania Division A' },
  { id: 285, name: 'Serbia A League' },
  { id: 209, name: 'Slovakia Extraliga' },
  { id: 173, name: 'Slovenia Liga Nova KBM' },
  { id: 203, name: 'Slovenia 2 SKL' },
  { id: 172, name: 'Israel Winner League' },
  { id: 240, name: 'Israel Winner League Play-offs' },
  { id: 100055, name: 'Spain LF Endesa W' },
  { id: 194, name: 'Spain LEB Gold' },
  { id: 227, name: 'Spain LEB Silver' },
  { id: 201, name: 'Switzerland SBL' },
  { id: 383, name: 'Switzerland NLB' },
  { id: 252, name: 'Turkey BSL Play-offs' },
  { id: 348, name: 'Turkey TBL' },
  { id: 234, name: 'Ukraine Superleague' },
  { id: 370, name: 'Preparation' },
  { id: 423, name: 'Basketball Champions League Qualifying Rounds' },
  { id: 311, name: 'FIBA Europe Cup Qualifying Rounds' },
  { id: 100091, name: 'Brazil NBB' },
].sort((a, b) => a.name.localeCompare(b.name))

const selectedLeagues = ref([3]) // Default to NBA
const searchQuery = ref('')
const startDate = ref('')
const endDate = ref('')
const showLeagueDropdown = ref(false)

// Filtered leagues based on search
const filteredLeagues = computed(() => {
  if (!searchQuery.value.trim()) {
    return leagues
  }
  const query = searchQuery.value.toLowerCase()
  return leagues.filter(league => 
    league.name.toLowerCase().includes(query) || 
    league.id.toString().includes(query)
  )
})

// Format date as YYYY-MM-DD
const formatDate = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// Initialize dates: previous date and current date
onMounted(() => {
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  
  startDate.value = formatDate(yesterday)
  endDate.value = formatDate(today)
  
  // Close dropdown when clicking outside
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})

const handleClickOutside = (event) => {
  const target = event.target
  if (!target.closest('.league-dropdown-container')) {
    showLeagueDropdown.value = false
  }
}

// Toggle league selection
const toggleLeague = (leagueId) => {
  const index = selectedLeagues.value.indexOf(leagueId)
  if (index > -1) {
    selectedLeagues.value.splice(index, 1)
  } else {
    selectedLeagues.value.push(leagueId)
  }
}

// Select all filtered leagues
const selectAllFiltered = () => {
  const filteredIds = filteredLeagues.value.map(l => l.id)
  filteredIds.forEach(id => {
    if (!selectedLeagues.value.includes(id)) {
      selectedLeagues.value.push(id)
    }
  })
}

// Deselect all filtered leagues
const deselectAllFiltered = () => {
  const filteredIds = filteredLeagues.value.map(l => l.id)
  selectedLeagues.value = selectedLeagues.value.filter(id => !filteredIds.includes(id))
}

// Get selected league names
const selectedLeagueNames = computed(() => {
  return selectedLeagues.value
    .map(id => leagues.find(l => l.id === id)?.name)
    .filter(Boolean)
})

// Generate command
const generatedCommand = computed(() => {
  const leagueIds = selectedLeagues.value.join(',')
  return `php artisan proballers:fetch-schedules --league=${leagueIds} --start-date=${startDate.value} --end-date=${endDate.value}`
})

const copyCommand = async () => {
  try {
    await navigator.clipboard.writeText(generatedCommand.value)
    alert('Command copied to clipboard!')
  } catch (err) {
    console.error('Failed to copy:', err)
    alert('Failed to copy command to clipboard')
  }
}

// Scrape functionality
const isScraping = ref(false)
const gamesResult = ref(null)
const showResults = ref(false)

// Expanded games and player data
const expandedGames = ref(new Set())
const gamePlayers = ref({})
const loadingPlayers = ref(new Set())

const scrapeGames = async () => {
  if (selectedLeagues.value.length === 0) {
    alert('Please select at least one league')
    return
  }

  isScraping.value = true
  gamesResult.value = null
  showResults.value = false
  expandedGames.value.clear()
  gamePlayers.value = {}

  try {
    const leagueIds = selectedLeagues.value.join(',')
    const response = await axios.post('/api/proballers/fetch-schedules', {
      league: leagueIds,
      start_date: startDate.value,
      end_date: endDate.value,
    })

    if (response.data.success) {
      gamesResult.value = response.data
      showResults.value = true
    } else {
      alert('Failed to fetch games: ' + (response.data.message || 'Unknown error'))
    }
  } catch (error) {
    console.error('Error scraping games:', error)
    alert('Error scraping games: ' + (error.response?.data?.message || error.message))
  } finally {
    isScraping.value = false
  }
}

const toggleGameExpansion = async (game) => {
  const gameId = game.gameId || game.id
  const isNotInDb = !game.inDatabase || game.rowCount === 0
  
  // Allow expansion for games not in DB (including scraped games)
  if (!isNotInDb) {
    console.log('Game is in DB, cannot expand:', gameId)
    return
  }
  
  console.log('Toggling expansion for game:', gameId, 'isScraped:', game.isScraped)
  
  if (expandedGames.value.has(gameId)) {
    expandedGames.value.delete(gameId)
  } else {
    expandedGames.value.add(gameId)
    
    // Fetch players if not already loaded
    if (!gamePlayers.value[gameId] && !loadingPlayers.value.has(gameId)) {
      console.log('Fetching players for game:', gameId)
      await fetchGamePlayers(gameId)
    } else {
      console.log('Players already loaded for game:', gameId, 'count:', gamePlayers.value[gameId]?.length)
    }
  }
}

const fetchGamePlayers = async (gameId, forceRescrape = false) => {
  if (loadingPlayers.value.has(gameId)) return
  
  loadingPlayers.value.add(gameId)
  
  try {
    // First, try to get from cache (if not forcing rescrape)
    if (!forceRescrape) {
      try {
        const cachedResponse = await axios.get(`/api/proballers/cached-boxscore/${gameId}`)
        if (cachedResponse.data.success && cachedResponse.data.players && cachedResponse.data.players.length > 0) {
          gamePlayers.value[gameId] = cachedResponse.data.players
          console.log(`✅ Loaded cached boxscore for game ${gameId} (${cachedResponse.data.players.length} players)`)
          loadingPlayers.value.delete(gameId)
          return
        }
      } catch (cacheError) {
        // Cache miss, continue to scrape
        console.log(`Cache miss for game ${gameId}, scraping...`)
      }
    }
    
    // If rescraping, use the rescrape endpoint
    if (forceRescrape) {
      const rescrapeResponse = await axios.post(`/api/proballers/rescrape-boxscore/${gameId}`)
      if (rescrapeResponse.data.success && rescrapeResponse.data.players && rescrapeResponse.data.players.length > 0) {
        gamePlayers.value[gameId] = rescrapeResponse.data.players
        console.log(`✅ Rescraped boxscore for game ${gameId} (${rescrapeResponse.data.players.length} players)`)
        loadingPlayers.value.delete(gameId)
        return
      }
    }
    
    // Fallback: Use Laravel API proxy endpoint to scrape
    const response = await axios.get(`/api/proballers/boxscore/${gameId}`)
    
    if (response.data.success && response.data.players && response.data.players.length > 0) {
      gamePlayers.value[gameId] = response.data.players
      if (response.data.scraped) {
        console.log(`✅ Successfully scraped boxscore for game ${gameId} (${response.data.players.length} players)`)
      }
    } else {
      gamePlayers.value[gameId] = []
    }
    
  } catch (error) {
    console.error(`Error fetching/scraping players for game ${gameId}:`, error)
    gamePlayers.value[gameId] = []
    
    // Show user-friendly error message
    if (error.response?.status === 404) {
      console.log(`Game ${gameId} could not be scraped. The game may not exist or the page structure may have changed.`)
    }
  } finally {
    loadingPlayers.value.delete(gameId)
  }
}

const formatDateTime = (datetime) => {
  if (!datetime) return 'N/A'
  const date = new Date(datetime)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}.${month}.${year} ${hours}:${minutes}`
}

// No cleanup needed - WebSocket connections are closed automatically when done
</script>

<template>
  <div class="flex flex-col h-full space-y-4">
    <!-- League Selection - Modern Multi-Select -->
    <div class="relative league-dropdown-container">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Leagues <span class="text-gray-500 text-xs">({{ selectedLeagues.length }} selected)</span>
      </label>
      
      <!-- Selected Leagues Display -->
      <div 
        @click="showLeagueDropdown = !showLeagueDropdown"
        class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white cursor-pointer hover:border-pink-500 transition-colors flex items-center justify-between min-h-[42px]"
      >
        <div class="flex-1 flex flex-wrap gap-1">
          <span 
            v-if="selectedLeagues.length === 0"
            class="text-gray-400 text-sm"
          >
            Select leagues...
          </span>
          <span
            v-for="leagueId in selectedLeagues.slice(0, 3)"
            :key="leagueId"
            class="inline-flex items-center gap-1 px-2 py-0.5 bg-pink-100 text-pink-800 text-xs rounded-full"
          >
            {{ leagues.find(l => l.id === leagueId)?.name }}
            <button
              @click.stop="toggleLeague(leagueId)"
              class="hover:text-pink-900"
            >
              <i class="fas fa-times text-xs"></i>
            </button>
          </span>
          <span
            v-if="selectedLeagues.length > 3"
            class="inline-flex items-center px-2 py-0.5 bg-gray-100 text-gray-700 text-xs rounded-full"
          >
            +{{ selectedLeagues.length - 3 }} more
          </span>
        </div>
        <i 
          :class="['fas', showLeagueDropdown ? 'fa-chevron-up' : 'fa-chevron-down', 'text-gray-400 text-sm']"
        ></i>
      </div>

      <!-- Dropdown -->
      <div
        v-if="showLeagueDropdown"
        class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-64 flex flex-col"
      >
        <!-- Search Bar -->
        <div class="p-2 border-b border-gray-200 sticky top-0 bg-white">
          <div class="relative">
            <i class="fas fa-search absolute left-2 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search leagues..."
              class="w-full pl-8 pr-8 py-1.5 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
              @click.stop
            />
            <button
              v-if="searchQuery"
              @click.stop="searchQuery = ''"
              class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <i class="fas fa-times text-xs"></i>
            </button>
          </div>
          
          <!-- Quick Actions -->
          <div class="flex gap-2 mt-2">
            <button
              @click.stop="selectAllFiltered"
              class="text-xs px-2 py-1 text-pink-600 hover:bg-pink-50 rounded"
            >
              Select All
            </button>
            <button
              @click.stop="deselectAllFiltered"
              class="text-xs px-2 py-1 text-gray-600 hover:bg-gray-50 rounded"
            >
              Deselect All
            </button>
          </div>
        </div>

        <!-- League List -->
        <div class="overflow-y-auto flex-1">
          <div
            v-for="league in filteredLeagues"
            :key="league.id"
            @click.stop="toggleLeague(league.id)"
            class="px-3 py-2 hover:bg-pink-50 cursor-pointer flex items-center gap-2 transition-colors"
            :class="{ 'bg-pink-50': selectedLeagues.includes(league.id) }"
          >
            <input
              type="checkbox"
              :checked="selectedLeagues.includes(league.id)"
              @change="toggleLeague(league.id)"
              @click.stop
              class="w-4 h-4 text-pink-600 border-gray-300 rounded focus:ring-pink-500"
            />
            <span class="flex-1 text-sm text-gray-700">{{ league.name }}</span>
            <span class="text-xs text-gray-500">ID: {{ league.id }}</span>
          </div>
          <div
            v-if="filteredLeagues.length === 0"
            class="px-3 py-4 text-center text-sm text-gray-500"
          >
            No leagues found
          </div>
        </div>
      </div>
    </div>

    <!-- Date Range -->
    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Start Date
        </label>
        <input
          v-model="startDate"
          type="date"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          End Date
        </label>
        <input
          v-model="endDate"
          type="date"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
        />
      </div>
    </div>

    <!-- Generated Command -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">
        Generated Command
      </label>
      <div class="flex items-center gap-2">
        <div class="flex-1 bg-gray-50 border border-gray-200 rounded-lg p-2.5">
          <code class="text-xs text-gray-800 break-all">{{ generatedCommand }}</code>
        </div>
        <button
          @click="copyCommand"
          class="px-3 py-2 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition-colors flex-shrink-0"
          title="Copy command to clipboard"
        >
          <i class="fas fa-copy text-sm"></i>
        </button>
      </div>
    </div>

    <!-- Scrape Button -->
    <div class="flex gap-2">
      <button
        @click="scrapeGames"
        :disabled="isScraping || selectedLeagues.length === 0"
        class="flex-1 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg hover:from-pink-600 hover:to-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        <i v-if="isScraping" class="fas fa-spinner fa-spin"></i>
        <i v-else class="fas fa-search"></i>
        <span>{{ isScraping ? 'Fetching...' : 'Fetch Available Games' }}</span>
      </button>
    </div>

    <!-- Results - Flex grow to fill space -->
    <div v-if="showResults && gamesResult" class="flex-1 flex flex-col min-h-0 border border-gray-200 rounded-lg overflow-hidden">
      <div class="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-4 py-2 flex items-center justify-between flex-shrink-0">
        <div>
          <h3 class="font-semibold text-sm">Available Games</h3>
          <p class="text-xs opacity-90">{{ gamesResult.totalGames }} total games</p>
        </div>
        <button
          @click="showResults = false"
          class="text-white hover:bg-white hover:bg-opacity-20 rounded p-1"
        >
          <i class="fas fa-times text-sm"></i>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto min-h-0">
        <div v-if="gamesResult.games.length === 0" class="p-4 text-center text-gray-500 text-sm">
          No games found for the selected criteria
        </div>
        <div v-else class="games-grid-container">
          <!-- Table Header -->
          <div class="games-grid-header">
            <div class="font-semibold text-gray-700">Teams</div>
            <div class="font-semibold text-gray-700">Game ID</div>
            <div class="font-semibold text-gray-700">Date/Time</div>
            <div class="font-semibold text-gray-700">Score</div>
            <div class="font-semibold text-gray-700">League</div>
            <div class="font-semibold text-gray-700">Status</div>
            <div class="font-semibold text-gray-700 text-center">Link</div>
          </div>

          <!-- Table Rows -->
          <div class="games-grid-body">
            <template v-for="game in gamesResult.games" :key="game.gameId || game.id">
              <div
                class="games-grid-row"
                :class="{
                  'hover:bg-gray-50': !expandedGames.has(game.gameId || game.id),
                  'bg-blue-50': expandedGames.has(game.gameId || game.id),
                  'cursor-pointer': !game.inDatabase || game.rowCount === 0
                }"
                @click="(!game.inDatabase || game.rowCount === 0) && toggleGameExpansion(game)"
              >
                <!-- Teams -->
                <div class="font-semibold text-gray-900">
                  {{ game.team1 || 'Team 1' }} vs {{ game.team2 || 'Team 2' }}
                </div>
                
                <!-- Game ID -->
                <div class="text-gray-600">
                  {{ game.gameId || 'N/A' }}
                </div>
                
                <!-- Date/Time -->
                <div class="text-gray-600">
                  {{ formatDateTime(game.datetime) }}
                </div>
                
                <!-- Score -->
                <div class="text-gray-600">
                  {{ game.score || '-' }}
                </div>
                
                <!-- League -->
                <div class="text-gray-600">
                  {{ game.leagueName || game.league || 'N/A' }}
                </div>
                
                <!-- Status Badge (Clickable for "Not in DB") -->
                <div>
                  <span
                    :class="[
                      game.inDatabase && game.rowCount > 0 ? 'bg-green-100 text-green-800' : 
                      game.isScraped ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800',
                      'px-2 py-1 rounded-full text-xs font-medium inline-flex items-center gap-1 whitespace-nowrap',
                      { 
                        'cursor-pointer hover:opacity-80': !game.inDatabase || game.rowCount === 0,
                        'cursor-default': game.inDatabase && game.rowCount > 0
                      }
                    ]"
                    @click.stop="(!game.inDatabase || game.rowCount === 0) && toggleGameExpansion(game)"
                    :title="(!game.inDatabase || game.rowCount === 0) ? 'Click to view players' : ''"
                  >
                    <i :class="[
                      'fas', 
                      game.inDatabase && game.rowCount > 0 ? 'fa-check-circle' : 
                      game.isScraped ? 'fa-download' : 'fa-times-circle'
                    ]"></i>
                    {{ game.inDatabase && game.rowCount > 0 ? 'In DB' : 
                       game.isScraped ? 'Scraped' : 'Not in DB' }}
                    <span v-if="game.inDatabase && game.rowCount > 0" class="ml-1">
                      ({{ game.rowCount }})
                    </span>
                    <span v-if="game.isScraped && (!game.inDatabase || game.rowCount === 0)" class="ml-1 text-xs">
                      (cached)
                    </span>
                    <i 
                      v-if="(!game.inDatabase || game.rowCount === 0) && expandedGames.has(game.gameId || game.id)"
                      class="fas fa-chevron-up ml-1 text-xs"
                    ></i>
                    <i 
                      v-else-if="!game.inDatabase || game.rowCount === 0"
                      class="fas fa-chevron-down ml-1 text-xs"
                    ></i>
                  </span>
                </div>
                
                <!-- Action Button -->
                <div class="text-center">
                  <a
                    v-if="game.gameLink"
                    :href="game.gameLink"
                    target="_blank"
                    class="text-blue-600 hover:text-blue-800 p-1.5 rounded transition-colors inline-block"
                    title="View Game"
                    @click.stop
                  >
                    <i class="fas fa-external-link-alt text-sm"></i>
                  </a>
                  <span v-else class="text-gray-300">-</span>
                </div>
              </div>
              
              <!-- Expanded Player List -->
              <div
                v-if="expandedGames.has(game.gameId || game.id)"
                class="bg-gray-50 border-t border-gray-200 p-4"
                style="grid-column: 1 / -1;"
              >
                <!-- Header with Refresh Button -->
                <div class="flex items-center justify-between mb-3">
                  <h4 class="text-sm font-semibold text-gray-700">Player Statistics</h4>
                  <button
                    @click="fetchGamePlayers(game.gameId || game.id, true)"
                    :disabled="loadingPlayers.has(game.gameId || game.id)"
                    class="px-3 py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                    title="Rescrape boxscore"
                  >
                    <i class="fas fa-sync-alt" :class="{ 'fa-spin': loadingPlayers.has(game.gameId || game.id) }"></i>
                    Refresh
                  </button>
                </div>
                
                <div v-if="loadingPlayers.has(game.gameId || game.id)" class="text-center py-4">
                  <i class="fas fa-spinner fa-spin text-gray-400 text-xl"></i>
                  <p class="text-sm text-gray-500 mt-2">Loading players...</p>
                </div>
                <div v-else-if="gamePlayers[game.gameId || game.id] && gamePlayers[game.gameId || game.id].length > 0" class="players-table-container">
                  <div class="players-table-header">
                    <div>Player</div>
                    <div>Team</div>
                    <div>Min</div>
                    <div>Pts</div>
                    <div>Reb</div>
                    <div>Ast</div>
                    <div>Stl</div>
                    <div>Blk</div>
                    <div>TO</div>
                    <div>FG%</div>
                    <div>3P%</div>
                    <div>FT%</div>
                  </div>
                  <div class="players-table-body">
                    <div
                      v-for="player in gamePlayers[game.gameId || game.id]"
                      :key="player.p_player_id || player.player_id"
                      class="players-table-row"
                    >
                      <div class="font-medium text-gray-900">{{ player.player_name }}</div>
                      <div class="text-gray-600">{{ player.team_name }}</div>
                      <div class="text-gray-600">{{ player.minutes || '-' }}</div>
                      <div class="text-gray-600">{{ player.points || '-' }}</div>
                      <div class="text-gray-600">{{ player.rebounds || player.total_rebounds || '-' }}</div>
                      <div class="text-gray-600">{{ player.assists || '-' }}</div>
                      <div class="text-gray-600">{{ player.steals || '-' }}</div>
                      <div class="text-gray-600">{{ player.blocks || '-' }}</div>
                      <div class="text-gray-600">{{ player.turnovers || '-' }}</div>
                      <div class="text-gray-600">{{ player.field_goal_percentage || '-' }}</div>
                      <div class="text-gray-600">{{ player.three_point_percentage || '-' }}</div>
                      <div class="text-gray-600">{{ player.free_throw_percentage || '-' }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center py-4 text-gray-500 text-sm">
                  No player data available for this game
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Summary -->
      <div class="bg-gray-50 px-4 py-2 border-t border-gray-200 text-xs text-gray-600 flex-shrink-0">
        <span class="font-medium">{{ gamesResult.gamesInDatabase }}</span> games in database
        <span class="mx-2">•</span>
        <span class="font-medium">{{ gamesResult.gamesNotInDatabase }}</span> games not in database
      </div>
    </div>

    <!-- Info -->
    <div class="bg-blue-50 border border-blue-200 rounded-lg p-2.5">
      <div class="flex items-start gap-2">
        <i class="fas fa-info-circle text-blue-600 mt-0.5 text-sm"></i>
        <div class="text-xs text-blue-700">
          <p class="font-medium mb-0.5">Usage:</p>
          <p>Copy the command above and run it in your terminal to fetch schedules from Proballers WebSocket.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Games Grid Layout */
.games-grid-container {
  display: flex;
  flex-direction: column;
}

.games-grid-header {
  display: grid;
  grid-template-columns: 2fr 0.8fr 1.3fr 0.8fr 0.9fr 1.2fr 0.6fr;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
}

.games-grid-body {
  display: flex;
  flex-direction: column;
}

.games-grid-row {
  display: grid;
  grid-template-columns: 2fr 0.8fr 1.3fr 0.8fr 0.9fr 1.2fr 0.6fr;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.15s ease;
  align-items: center;
}

.games-grid-row:last-child {
  border-bottom: none;
}

/* Players Table */
.players-table-container {
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
}

.players-table-header {
  display: grid;
  grid-template-columns: 2fr 1.5fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.8fr 0.8fr 0.8fr;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #6b7280;
  position: sticky;
  top: 0;
  z-index: 5;
}

.players-table-body {
  display: flex;
  flex-direction: column;
}

.players-table-row {
  display: grid;
  grid-template-columns: 2fr 1.5fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.8fr 0.8fr 0.8fr;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.875rem;
  align-items: center;
  transition: background-color 0.15s ease;
}

.players-table-row:hover {
  background-color: #f9fafb;
}

.players-table-row:last-child {
  border-bottom: none;
}

/* Custom scrollbar for games list */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

/* Custom scrollbar for players table */
.players-table-container::-webkit-scrollbar {
  width: 6px;
}

.players-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.players-table-container::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

.players-table-container::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}
</style>
